










































































import Vue from "vue";
import userInfoProvider from "@/services/userInfoProvider";
import OtpFormInput from "../partials/OtpFormInput.vue";
import identityAuthenClient from "@/services/identityAuthenClient";
import defaultDataProviderFactory from "@/services/identity-authen/defaultDataProvider";
import {
  LOWER_CASE_REGEX,
  STRING_CONTAIN_NUMBER_REGEX,
  UPPER_CASE_REGEX,
} from "@/constant/regex";
import router from "@/router";
import RequestUnlock from "@/constant/request-unlock";

const defaultDataProvider = defaultDataProviderFactory();

export default Vue.extend({
  name: "ForgotPassword",
  components: {OtpFormInput},
  data() {
    const self: any = this;
    return {
      messageForTheFirstTime: "",
      formValue: {
        newPassword: "",
        confirmPassword: "",
      },
      matchPassword: null as any,
      passwordCondition: {
        length: false,
        numberCharacter: false,
        leterCase: false,
      },
      rules: {
        required: (value) => {
          return !!value || "Required";
        },
        newPassword: (value) => {
          return self.doneTypingNewPassword() || "invalid";
        },
        comparePassword: (value) => {
          return self.comparePassword() || "Not match";
        },
      },
      error: "",
      changePasswordForFirstTime: false,
      loading: false,
      isShowSelectMethod: false,
      message: "",
      loginName: "",
      otp: "",
      data: {},
      token: "",
      type: "",
      totpCodeInput: ["", "", "", "", "", ""],
      isWaiting: false,
      form: false,
      confirmPasswordDirty: false,
      smsMethod: false,
      emailMethod: false,
      selectingMethod: false,
      validOtp: false,
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    validateAll(event) {
      (this.$refs.form as any).validate();

      if (event.which === 13 || event.keyCode === 13) {
        if (this.form) {
          this.changePassword();
        }
      }
    },
    onReadyToSubmit(mfaData) {
      this.otp = mfaData.otp;
      this.submit(this.type)
    },
    async submit(type: string = "Sms") {
      let query: any;
      this.error = ""
      query = {
        otp: this.otp,
        token: this.token,
        type: type || this.type,
      };
      try {
        const data = await identityAuthenClient.requestUnlockOtp(query);
        if (data.error_info && data.error_info.error_code) {
          this.error = data.error_info.message
          return
        }
        await this.$router.push({
          name: 'request-unlock-success'
        });
      } catch (error) {
        this.error = error;
        this.isWaiting = false;
      }
    },
    async selectMethodOption(type: string) {
      this.isShowSelectMethod = false
      await this.onRequestUnlock(type)
    },
    haveAllowMethod() {
      let countAllowMethod = 0;
      if (this.data && this.data.available_types && this.data.available_types.length > 0) {
        for (const method of this.data.available_types) {
          if (method.type === 'Sms' || method.type === 'Email') {
            countAllowMethod += 1;
          }
        }
        return countAllowMethod === 2;
      }
      return false;
    },
    containMethod(type) {
      for (const method of this.data.available_types) {
        if (method.type === type) {
          return true;
        }
      }
      return false;
    },
  },
  async created() {
    let query = this.$route.query
    if (query) {
      query = JSON.parse(decodeURIComponent(escape(atob(query))));
      this.data = query.available_types
      if (query.token) {
        this.token = query.token
      }
      if (query.login_name) {
        this.loginName = query.login_name
      }
      if (query.available_types && Array.isArray(query.available_types) && query.available_types.length > 1) {
        this.isShowSelectMethod = true
      } else {
        this.type = query.available_types && Array.isArray(query.available_types) && query.available_types[0].type
        this.message = query.available_types && Array.isArray(query.available_types) && query.available_types[0].message
      }
    }

  },
});
